const CHUNK_SIZE_BYTES = 3 * 1024 * 1024;

const readBlobAsArrayBuffer = (blob) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onload = () => resolve(reader.result);
		reader.onerror = () => {
			reject(reader.error || new Error("Failed to read file"));
		};

		reader.readAsArrayBuffer(blob);
	});

const arrayBufferToBase64 = (arrayBuffer) => {
	const bytes = new Uint8Array(arrayBuffer);
	const bytesLength = bytes.length;
	let binary = "";
	const step = 0x8000;

	for (let index = 0; index < bytesLength; index += step) {
		const chunk = bytes.subarray(index, Math.min(index + step, bytesLength));
		binary += String.fromCharCode(...chunk);
	}

	return btoa(binary);
};

export const fileToBase64 = async (file) => {
	if (!file) {
		return "";
	}

	const size = Number(file?.size ?? 0);
	if (size <= 0) {
		return "";
	}

	try {
		let base64 = "";

		for (let offset = 0; offset < size; offset += CHUNK_SIZE_BYTES) {
			const slice = file.slice(offset, Math.min(offset + CHUNK_SIZE_BYTES, size));
			const buffer = await readBlobAsArrayBuffer(slice);

			if (buffer) {
				base64 += arrayBufferToBase64(buffer);
			}
		}

		return base64;
	} catch (error) {
		console.error("Failed to convert file to Base64", error);
		return "";
	}
};
